import { Form, Input } from "antd";
import { useContext } from "react";
import { useNavigate } from "react-router";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import { Credentials } from "../entity/auth.model";
import { authService } from "../service/auth.service";

function Login() {
  const navigate = useNavigate();
  const { dispatch } = useContext(SpinContext);

  const onFinish = (values: Credentials) => {
    dispatch({ type: spinActions.BLOCK });
    authService
      .login(values)
      .then(() => {
        dispatch({ type: spinActions.UNBLOCK });
        navigate("/users");
      })
      .catch(() => {
        dispatch({ type: spinActions.UNBLOCK });
      });
  };

  return (
    <div className="content d-flex justify-content-center align-items-center">
      <Form name="login" onFinish={onFinish} className="login-form">
        <div className="card mb-0">
          <div className="card-body">
            <div className="text-center mb-2">
              <img
                src="/assets/images/Logo.svg"
                alt=""
                height="70"
                className="mt-3 mb-2"
              />

              <span className="d-block text-muted">
                Админ эрхээрээ нэвтэрнэ үү
              </span>
            </div>
            <div className="form-group form-group-feedback form-group-feedback-left">
              <Form.Item
                name="username"
                rules={[
                  {
                    required: true,
                    message: "Нэвтрэх нэрээ оруулна уу.",
                  },
                ]}
              >
                <Input placeholder="Нэвтрэх нэр" className="form-control" />
              </Form.Item>
              <div className="form-control-feedback">
                <i className="icon-user text-muted" />
              </div>
            </div>
            <div className="form-group form-group-feedback form-group-feedback-left">
              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Нууц үгээ оруулна уу.",
                  },
                ]}
              >
                <Input.Password
                  placeholder="Нууц үг"
                  className="form-control"
                />
              </Form.Item>
              <div className="form-control-feedback">
                <i className="icon-lock2 text-muted" />
              </div>
            </div>
            <div className="form-group">
              <button type="submit" className="btn btn-primary btn-block">
                Нэвтрэх
                <i className="icon-circle-right2 ml-2" />
              </button>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
}

export default Login;
